export default "__VITE_ASSET__C$zyNPET__"